define('sportsbook',['module', 'jquery', 'all/player/session', 'all/footer', 'all/jquery/jquery.url'], function(module, $, session, footer) {
	'use strict';

	var CONTAINER_ID = 'sportsbook-container',
        IFRAME_ID = 'sportsbook-frame',
        sportsbook = {},
        configuration = module.config(),
        SPORTS = 'sports',
        LIVE_BETTING = 'live-betting';

	function setupPostMessage() {
		if (window.postMessage) {
			if (!window.addEventListener) {
				window.addEventListener = function(n, f) {
					window.attachEvent('on' + n, function() {
						f(event);
					});
				};
			}
			addEventListener('message', function(event) {
				var sizeStr = event.data;
				var newHeight = parseInt(sizeStr, 10);
				if (isNaN(newHeight)) {
					if (event.data.length >= 5 && event.data.substr(0, 5) === 'start') {
						window.location.href = '/Sportsbook';
					} else if (event.data.length >= 6 && event.data.substr(0, 6) === 'reload') {
						var obj = window.top.swfobject.getObjectById('userInfo');
						if (obj) {
							window.location.href = '/Sportsbook';
						}
					}
				} else {
                    if (configuration.src.indexOf(event.origin) !== -1) {
                        window.top.resizeIframeInit(IFRAME_ID, newHeight);
                    }
				}
			}, false);
		}
	}

	function setupOnloadVisibleCallback() {
		var bodyFrame = document.getElementById(IFRAME_ID);
		bodyFrame.onload = function() {
			bodyFrame.style.visibility = 'visible';
			$('#sportsbook-wrapper').show();

			footer.show();
			footer.pixelTrack('SPORTSBOOK');
		};
	}

	function loadSportsbookFrame() {
        var src,
            $liveBetting = $('#' + LIVE_BETTING);

        if ($liveBetting.hasClass('active')) {
            src = createFrameSrc(LIVE_BETTING);
        } else {
            src = createFrameSrc(SPORTS);
        }

		var $container = $('#' + CONTAINER_ID);

		var $iframe = $('<iframe>', {
			id: IFRAME_ID,
			src: src,
			style: 'visibility: hidden',
			marginheight: '0',
			marginwidth: '0',
			frameborder: '0',
			allowTransparency: 'true',
			scrolling: 'no'
		});

		$iframe.width(configuration.width);
		$iframe.height(configuration.height);
        $iframe.css('max-width','1500px');
		$container.html($iframe);

		setupOnloadVisibleCallback();
	}

    function setTypeOfSportsbook(src, typeOfSportsbook) {
        var url, parameters, domainArray;

        if (typeOfSportsbook === LIVE_BETTING) {
            domainArray = src.split('?');

            url = domainArray[0];
            parameters = domainArray[1];

            url = url.replace('.com/' + SPORTS, '.com/' + LIVE_BETTING);
            src = url + '?' + parameters;
        }
        return src;
    }

    function createFrameSrc(typeOfSportsbook) {
		var src = configuration.src,
            sbpage = $.url().param('sbpage');

        src = setTypeOfSportsbook(src, typeOfSportsbook);
        if (sbpage !== undefined && sbpage.length > 0) {
			if (sbpage[0] !== '/') {
				sbpage = '/' + sbpage;
			}
			src.replace('/' + typeOfSportsbook + '/', sbpage);
		}
		return src;
	}

	sportsbook.preload = loadSportsbookFrame;

	sportsbook.load = function() {
		$(session).on('login logout', loadSportsbookFrame);
		setupPostMessage();
	};

	return sportsbook;
});

